import axios from "axios";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";

export function getUserCookie() {
  const userToken = Cookies.get("user_token");
  const userData = userToken ? jwtDecode(userToken) : null;
  return userData;
}

export function updateTokenUserCookie() {
  const userToken = Cookies.get("user_token");
  // 只有在存在有效令牌时才发送刷新请求
  if (userToken && userToken.trim() !== "") {
    axios
      .post("/auth/login", {
        requesterToken: userToken,
      })
      .then((response) => {
        Cookies.set("user_token", response.data.token);
      })
      .catch((error) => {
        // 静默处理错误，避免打断用户体验
        console.warn("Token refresh failed:", error.response?.data || error.message);
      });
  }
}
